import { Base } from '../base/index.js';

/**
 * Component's name.
 * @type {string}
 */
export const name = 'tabs';

/**
 * Class Foo.
 */
export class Tabs extends Base {
  /**
   * @type {import('../../types.d.ts').BaseConfig}
   */
  static config = {
    name,
  };

  connectedCallback() {
    this.getElements();
  }

  /**
   * getElements
   */
  getElements() {
    this.btns = Array.from(this.querySelectorAll('.tab-btn'));
    this.tabs = this.querySelectorAll('unistra-tab');

    for (const button of this.btns) {
      button.setAttribute('tabindex', button.getAttribute('aria-selected') === 'true' ? '0' : '-1');
      button.addEventListener('click', this.onBtnClick.bind(this));
    }

    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  /**
   * Activate a tab: update aria-selected/tabindex on every button and swap
   * the active panel, without moving focus (callers decide that).
   * @param {HTMLElement} button
   */
  activateTab(button) {
    const contentSelector = button.getAttribute('aria-controls');

    for (const btn of this.btns) {
      const isSelected = btn === button;
      btn.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      btn.setAttribute('tabindex', isSelected ? '0' : '-1');
    }

    for (const tab of this.tabs) {
      tab.classList.remove('active');
    }
    const contentTarget = this.querySelector(`#${contentSelector}`);
    contentTarget.classList.add('active');
  }

  /**
   * onClick
   * @param {Event} event
   */
  onBtnClick(event) {
    this.activateTab(event.target);
  }

  /**
   * Roving tabindex keyboard navigation, per the WAI-ARIA APG tabs pattern.
   * @see https://www.w3.org/WAI/ARIA/apg/patterns/tabs/
   * @param {KeyboardEvent} event
   */
  onKeydown(event) {
    if (!this.btns.includes(event.target)) {
      return;
    }

    const currentIndex = this.btns.indexOf(event.target);
    let newIndex;

    switch (event.key) {
      case 'ArrowRight':
        newIndex = (currentIndex + 1) % this.btns.length;
        break;
      case 'ArrowLeft':
        newIndex = (currentIndex - 1 + this.btns.length) % this.btns.length;
        break;
      case 'Home':
        newIndex = 0;
        break;
      case 'End':
        newIndex = this.btns.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    const newButton = this.btns[newIndex];
    this.activateTab(newButton);
    newButton.focus();
  }
}

export default Tabs;
